import { Category } from "../nyt";
import { fetchReason } from "../openAi/fetchReason";
import { Answer } from "./sortCorrectAndIncorrectAnswers";

export default async function getReasonsForIncorrectAnswers(
  sorted: Category[],
  answers: Answer[],
  scoreValue: number
): Promise<Answer[]> {
  const reasons = await Promise.all(
    answers.map(async (answer) => {
      if (answer.reason !== undefined) {
        console.log("this should hit");
        console.log(answer);
        return answer;
      }

      if (answer.correctCategory === answer.givenCategory) {
        return {
          ...answer,
          reason: "Correct!",
          score: scoreValue,
        };
      }

      const reason = await fetchReason(
        answer.bookTitle,
        sorted[answer.correctCategory].category_name,
        sorted[answer.givenCategory].category_name,
        sorted
      );

      return {
        ...answer,
        reason,
      };
    })
  );

  return reasons;
}
